// /blog/page.js
import React, { useState, useEffect } from "react";
import { Container, Header, Segment, Grid, Card, Icon, Button, Image } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import Feed from '@components/Feed';
import '@styles/BlogBody.css';


const Blog = () => {
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add Open Graph meta tags for blog page
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    document.title = 'Blog - Cloud CZR | Technology, History & Mindfulness Articles';
    updateMetaTag('og:title', 'Blog - Cloud CZR | Technology, History & Mindfulness Articles');
    updateMetaTag('og:description', 'Explore insightful articles on technology, historical perspectives, and mindfulness practices. Stay informed with the latest trends and timeless wisdom.');
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:image', `${window.location.origin}/assets/CloudChiRho.png`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', 'Explore insightful articles on technology, historical perspectives, and mindfulness practices. Stay informed with the latest trends and timeless wisdom.', false);
    updateMetaTag('twitter:title', 'Blog - Cloud CZR | Technology, History & Mindfulness Articles', false);
    updateMetaTag('twitter:description', 'Explore insightful articles on technology, historical perspectives, and mindfulness practices. Stay informed with the latest trends and timeless wisdom.', false);
  }, []);
  const path = "blog";
  const categories = [
    {
      title: "History",
      description: "Exploring the past to understand the present and envision the future.",
      icon: "book",
      color: "#702963",
    },
    {
      title: "Mindfulness",
      description: "Cultivating a balanced and mindful life through intentional practices.",
      icon: "leaf",
      color: "#702963",
    },
    {
      title: "Technology",
      description: "Staying at the forefront of tech advancements and innovations.",
      icon: "computer",
      color: "#702963",
    },
  ];

  return (
    <div class="ui-segment">
      <Container style={{ marginTop: "2em" }}>
      <Header as='h1' textAlign='center' icon style={{ color: '#a9885c' }}>
        <Image src={`${process.env.PUBLIC_URL}/assets/Blog.svg`} style={{ width: isDesktop ? '65%' : '100%', height: 'auto', margin: '0 auto 15px auto', display: 'block' }} />
      </Header>

      <Segment raised padded>
          <Grid stackable columns={3} divided>
            {categories.map((category, index) => (
              <Grid.Column key={index}>
                <Segment raised >
                  <Header as="h3" icon style={{ color: '#a9885c' }}>
                    <Icon name={category.icon} className="custom-icon-body" />
                    {category.title}
                  </Header>
                  <p>{category.description}</p>
                  <Button
                    fluid
                    className="custom-button-body"
                    onClick={() => navigate(`/blog/${category.title.toLowerCase()}`)}
                  >
                    Explore {category.title}
                  </Button>
                </Segment>
              </Grid.Column>
            ))}
          </Grid>
        </Segment>
        <Feed path={path} />
      </Container>
    </div>
  );
};

export default Blog;
